export const INITIAL_START_TIME_VALUE = "09:00";
export const INITIAL_END_TIME_VALUE = "17:00";
